import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';

interface IProps {
  width?: number;
  style?: StyleProp<ViewStyle>;
}

export default (props: IProps) => {
  const {width: size} = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1942_368)">
        <path
          d="M15 28.125C11.519 28.125 8.18064 26.7422 5.71922 24.2808C3.25781 21.8194 1.875 18.481 1.875 15C1.875 11.519 3.25781 8.18064 5.71922 5.71922C8.18064 3.25781 11.519 1.875 15 1.875C18.481 1.875 21.8194 3.25781 24.2808 5.71922C26.7422 8.18064 28.125 11.519 28.125 15C28.125 18.481 26.7422 21.8194 24.2808 24.2808C21.8194 26.7422 18.481 28.125 15 28.125ZM15 30C18.9782 30 22.7936 28.4196 25.6066 25.6066C28.4196 22.7936 30 18.9782 30 15C30 11.0218 28.4196 7.20644 25.6066 4.3934C22.7936 1.58035 18.9782 0 15 0C11.0218 0 7.20644 1.58035 4.3934 4.3934C1.58035 7.20644 0 11.0218 0 15C0 18.9782 1.58035 22.7936 4.3934 25.6066C7.20644 28.4196 11.0218 30 15 30Z"
          fill="#0088FF"
        />
        <path
          d="M13.125 21.5625C13.125 21.3139 13.2238 21.0754 13.3996 20.8996C13.5754 20.7238 13.8139 20.625 14.0625 20.625H15.9375C16.1861 20.625 16.4246 20.7238 16.6004 20.8996C16.7762 21.0754 16.875 21.3139 16.875 21.5625C16.875 21.8111 16.7762 22.0496 16.6004 22.2254C16.4246 22.4012 16.1861 22.5 15.9375 22.5H14.0625C13.8139 22.5 13.5754 22.4012 13.3996 22.2254C13.2238 22.0496 13.125 21.8111 13.125 21.5625ZM9.375 15.9375C9.375 15.6889 9.47377 15.4504 9.64959 15.2746C9.8254 15.0988 10.0639 15 10.3125 15H19.6875C19.9361 15 20.1746 15.0988 20.3504 15.2746C20.5262 15.4504 20.625 15.6889 20.625 15.9375C20.625 16.1861 20.5262 16.4246 20.3504 16.6004C20.1746 16.7762 19.9361 16.875 19.6875 16.875H10.3125C10.0639 16.875 9.8254 16.7762 9.64959 16.6004C9.47377 16.4246 9.375 16.1861 9.375 15.9375ZM5.625 10.3125C5.625 10.0639 5.72377 9.8254 5.89959 9.64959C6.0754 9.47377 6.31386 9.375 6.5625 9.375H23.4375C23.6861 9.375 23.9246 9.47377 24.1004 9.64959C24.2762 9.8254 24.375 10.0639 24.375 10.3125C24.375 10.5611 24.2762 10.7996 24.1004 10.9754C23.9246 11.1512 23.6861 11.25 23.4375 11.25H6.5625C6.31386 11.25 6.0754 11.1512 5.89959 10.9754C5.72377 10.7996 5.625 10.5611 5.625 10.3125Z"
          fill="#0088FF"
        />
      </g>
    </svg>
  );
};
